import React, { useMemo, useState } from 'react';
import MultiSelect, { Group, Option } from '../MultiSelect';
import TagsInput from '../TagsInput/TagsInput';
import { useGroupOptions } from '../utils';

interface TagsMultiSelectProps {
  options: (Option | Group)[];
  selectedValues: string[];
  onChange: (selectedOptionValues: string[]) => void;
  placeholder?: string;
  disabledOptions?: string[];
}

function TagsMultiSelect({
  options,
  selectedValues,
  onChange,
  placeholder,
  disabledOptions = [],
}: TagsMultiSelectProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const groupUtils = useGroupOptions(options);

  const filteredOptions = useMemo(() => {
    return groupUtils.filterOptions(searchTerm);
  }, [options, searchTerm]);

  const visibleTags = useMemo(() => {
    return selectedValues.map((option) => ({
      label: groupUtils.getOption(option).label,
      value: option,
    }));
  }, [selectedValues, groupUtils]);

  return (
    <MultiSelect
      options={filteredOptions}
      selectedOptions={selectedValues}
      onChange={onChange}
      searchTerm={searchTerm}
      onSearch={setSearchTerm}
      position="bottom-end"
      onClose={() => setSearchTerm('')}
      fullWidth
      searchable
      disabledOptions={disabledOptions}
      renderButton={({ onClick }) => (
        <div>
          <TagsInput
            role="combobox"
            onClick={onClick}
            onRemove={(tag) =>
              onChange(selectedValues.filter((value) => value !== tag.value))
            }
            placeholder={placeholder}
            tags={visibleTags}
          />
        </div>
      )}
    />
  );
}

export default TagsMultiSelect;
